<template>
  <div class="replaceRecord-container">
    <el-row>
      <el-form inline :model="queryForm" ref="queryForm" @submit.native.prevent>
        <el-form-item class="r-20" prop="plateNum">
          <el-input
            placeholder="车牌号"
            @keyup.enter.native="query"
            v-model.trim="queryForm.plateNum"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="name">
          <el-input
            placeholder="车辆绑定人"
            @keyup.enter.native="query"
            v-model.trim="queryForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="time">
          <el-date-picker
            class="datetime-picker"
            type="date"
            placeholder="部门更换时间"
            v-model="queryForm.time"
            value-format="yyyy-MM-dd"
            :picker-options="dateOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="r-20" prop="deptIds">
          <el-cascader
            v-model="queryForm.deptIds"
            :options="deptList"
            :props="optionProps"
            collapse-tags
            placeholder="现使用部门"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item class="r-20">
          <el-button type="primary" @click="query">查询</el-button>
          <el-button @click="reset">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
      >
        <el-table-column width="20"></el-table-column>
        <el-table-column type="index" label="序号" width="70"></el-table-column>
        <el-table-column
          label="车牌号"
          prop="plateNum"
          min-width="100"
        ></el-table-column>
        <el-table-column
          label="车辆绑定人"
          prop="name"
          min-width="100"
        ></el-table-column>
        <el-table-column label="联系电话" prop="phone"></el-table-column>
        <el-table-column
          label="部门更换时间"
          min-width="160"
          prop="startTime"
        ></el-table-column>
        <el-table-column
          label="使用部门"
          prop="deptName"
          min-width="160"
        ></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "replaceRecord",
  data() {
    return {
      queryForm: {
        plateNum: "",
        name: "",
        time: "",
        deptIds: [],
      },
      deptList: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      limit: 10,
      optionProps: {
        value: "id",
        multiple: true,
      },
      dateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    this.getDeptList();
    this.getTableData();
  },
  methods: {
    query() {
      console.log(this.queryForm);
      this.getTableData();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getTableData();
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableData();
    },

    handleDeptList(deptList) {
      deptList.forEach((item) => {
        if (item.children.length == 0) {
          item.children = null;
        } else {
          this.handleDeptList(item.children);
        }
      });
      return deptList;
    },
    async getDeptList() {
      let { data: res } = await this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        let data = this.handleDeptList(res.data);
        this.deptList = data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    async getTableData() {
      let obj = {};
      obj.page = this.currentPage;
      obj.limit = this.limit;
      obj.plateNum = this.queryForm.plateNum;
      obj.name = this.queryForm.name;
      obj.deptIds = this.queryForm.deptIds.join(", ");
      obj.startTime = this.queryForm.time;
      let { data: res } = await this.$axios.get("/api/vehicleDept/list", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.replaceRecord-container {
  height: calc(100% - 80px);
  margin: 20px;
  padding: 20px;
  background: #fff;

  ::v-deep .el-input__inner {
    padding-left: 15px;
    height: 32px !important;
  }
  ::v-deep .el-cascader__tags {
    width: 60%;
    flex-wrap: nowrap;
  }
  ::v-deep .el-input__prefix {
    color: #333;
    // 设置默认值消除原来格式的影响
    left: auto;
    right: 5px;
    .el-icon-time:before {
      content: "\e78e";
    }
  }

  .datetime-picker {
    ::v-deep .el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        display: none;
      }
    }
  }
}
</style>
